// ⚠️ CRITICAL: DEPRECATED - DEBUG COMPONENT IN PRODUCTION
// @src/pre-deployment/src/components/VocabularyFeature.js [DEPRECATED]
//
// STATUS: DEPRECATED - Debug component, NOT production-ready
// REASON: This is a barebones debug component with no real learning functionality
// MIGRATION: Update LearningModulesOrder.json to use VocabularyLearn for "vocabulary" module key
// CRITICAL: Currently used in production via "vocabulary" module key in ALL chapters
// ACTION REQUIRED: Migrate immediately - users are getting debug placeholder instead of real learning
//
// Original comments:
// VocabularyFeature - Barebones Debug Version
// Removed data searching and tracking to isolate module loading issues.

import React, { useState, useEffect } from 'react';
import './VocabularyFeature.css';
const VocabularyFeature = ({
    data,
    onComplete,
    _onAction,
    isTestMode = false
}) => {
    const [mountedAt] = useState(new Date().toISOString());

    console.log('🔄 [DIAG-VOCAB] Barebones component rendering');

    useEffect(() => {
        console.log('✅ [DIAG-VOCAB] Component mounted successfully');
    }, []);

    // Simple Auto-Test Trigger
    const handleAutoTest = () => {
        console.log('🧪 [DIAG-VOCAB] Triggering Auto-Test success');
        if (onComplete) onComplete({ success: true, score: 100 });
    };

    return (
        <div style={{
            padding: '40px',
            background: '#fff',
            borderRadius: '20px',
            boxShadow: '0 10px 30px rgba(255,165,0,0.1)',
            textAlign: 'center',
            border: '2px solid #FFA500',
            margin: '20px'
        }}>
            <h2 style={{ color: '#FFA500' }}>Vocabulary Feature - Debug Mode</h2>
            <p>Module loaded at: {mountedAt}</p>

            <div style={{ margin: '30px 0', padding: '20px', background: '#f9f9f9', borderRadius: '10px' }}>
                <strong>Debug Info:</strong>
                <pre style={{ textAlign: 'left', fontSize: '12px' }}>
                    {JSON.stringify({ hasData: !!data, isTestMode }, null, 2)}
                </pre>
            </div>

            <button
                id="auto-test-btn"
                onClick={handleAutoTest}
                style={{
                    padding: '12px 24px',
                    background: '#FFA500',
                    color: 'white',
                    border: 'none',
                    borderRadius: '8px',
                    cursor: 'pointer',
                    fontWeight: 'bold'
                }}
            >
                🚀 RUN AUTO-TEST
            </button>

            <p style={{ marginTop: '20px', fontSize: '12px', color: '#666' }}>
                Search tools used: broad grep, config audit.
            </p>
        </div>
    );
};

export default VocabularyFeature;
